/* For components with default copy that may be used in the student project, these helpers
 * can enable copy to be switched between translated and untranslated text.
 */

import {exhaustive} from '@freckle/exhaustive'

export type StringT =
  | {
      tag: 'with-translation'
      str: string
      translatorFn: (str: string) => string
    }
  | {
      tag: 'without-translation'
      str: string
    }

export function translateStr(str: StringT): string {
  switch (str.tag) {
    case 'with-translation':
      return str.translatorFn(str.str)
    case 'without-translation':
      return str.str
    default:
      return exhaustive(str, 'TitleT')
  }
}

export function mapString(fn: (a: string) => string, inStr: StringT): StringT {
  switch (inStr.tag) {
    case 'with-translation':
      return {
        ...inStr,
        str: fn(inStr.str)
      }
    case 'without-translation':
      return {
        tag: 'without-translation',
        str: fn(inStr.str)
      }
    default:
      return exhaustive(inStr)
  }
}

export function isStringEqual(a: StringT, b: StringT): boolean {
  switch (a.tag) {
    case 'with-translation':
      switch (b.tag) {
        case 'with-translation':
          return a.str === b.str
        case 'without-translation':
          return false
        default:
          return exhaustive(b)
      }
    case 'without-translation':
      switch (b.tag) {
        case 'with-translation':
          return false
        case 'without-translation':
          return a.str === b.str
        default:
          return exhaustive(b)
      }
    default:
      return exhaustive(a)
  }
}
